/* eslint-disable max-len */
import * as React from 'react';

var Error = function Error() {
  return /*#__PURE__*/React.createElement("svg", {
    className: "osui-empty-error-img",
    width: "600",
    height: "362",
    viewBox: "0 0 600 362",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, /*#__PURE__*/React.createElement("title", null, "\u7F3A\u7701\u9875/\u9519\u8BEF"), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5F5F5",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CECBCB",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5F5F5",
    stopOpacity: "0.432938156",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#666666",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "path-3",
    points: "143.850865 50.625 450.535853 50.625 596.25 120 0 120"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    maskContentUnits: "userSpaceOnUse",
    maskUnits: "objectBoundingBox",
    x: "0",
    y: "0",
    width: "596.25",
    height: "69.375",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0.994613904%",
    x2: "50%",
    y2: "99.4298986%",
    id: "linearGradient-5"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCCCCC",
    stopOpacity: "0",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#666666",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0.994613904%",
    x2: "50%",
    y2: "99.4298986%",
    id: "linearGradient-6"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCCCCC",
    stopOpacity: "0",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#666666",
    offset: "100%"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\u7F3A\u7701\u9875",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-779.000000, -454.000000)",
    id: "\u7F3A\u7701\u9875/\u9519\u8BEF"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(779.000000, 454.000000)"
  }, /*#__PURE__*/React.createElement("use", {
    id: "Rectangle-9-Copy-3\u5907\u4EFD-5",
    stroke: "url(#linearGradient-2)",
    mask: "url(#mask-4)",
    strokeWidth: "3.75",
    fill: "url(#linearGradient-1)",
    opacity: "0.210635231",
    strokeDasharray: "3.75",
    xlinkHref: "#path-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.697885,299.0625 L593.226053,338.4375 L8.56560187,338.4375 L146.309591,299.0625 L453.697885,299.0625 Z",
    id: "Rectangle-9-Copy-3\u5907\u4EFD-6",
    stroke: "#CCCCCC",
    strokeWidth: "1.875",
    fill: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-18\u5907\u4EFD-2",
    transform: "translate(440.625000, 292.500000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.78125,0.9375 L25.78125,22.5 C25.78125,24.8299513 24.8368506,26.9393263 23.3099635,28.4662135 C21.7830763,29.9931006 19.6737013,30.9375 17.34375,30.9375 L17.34375,30.9375 L9.375,30.9375 C7.04504871,30.9375 4.93567371,29.9931006 3.40878653,28.4662135 C1.88189936,26.9393263 0.9375,24.8299513 0.9375,22.5 L0.9375,22.5 L0.9375,0.9375 L25.78125,0.9375 Z",
    id: "Rectangle-7",
    stroke: "#CCCCCC",
    strokeWidth: "1.875",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-8",
    fill: "#FFFFFF",
    x: "1.484375",
    y: "1.51785714",
    width: "23.75",
    height: "6.07142857"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-8-Copy",
    stroke: "#CCCCCC",
    strokeWidth: "1.875",
    fill: "#EBEBEB",
    x: "3.90625",
    y: "16.1160714",
    width: "5.546875",
    height: "5.71428571"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-9",
    stroke: "#CCCCCC",
    strokeWidth: "1.875",
    fill: "#D8D8D8",
    x: "6.875",
    y: "2.45535714",
    width: "1",
    height: "11.7857143"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.8404018,10.1450893 L37.8404018,11.5513393 C37.8404018,13.1046401 37.2108022,14.5108901 36.1928774,15.5288149 C35.1749526,16.5467397 33.7687026,17.1763393 32.2154018,17.1763393 L32.2154018,17.1763393 L28.6439732,17.1763393 C27.0906724,17.1763393 25.6844224,16.5467397 24.6664976,15.5288149 C23.6485728,14.5108901 23.0189732,13.1046401 23.0189732,11.5513393 L23.0189732,11.5513393 L23.0189732,10.1450893 L37.8404018,10.1450893 Z",
    id: "Rectangle-7-Copy",
    stroke: "#CCCCCC",
    strokeWidth: "1.875",
    fill: "#FFFFFF",
    transform: "translate(30.429688, 13.660714) rotate(-90.000000) translate(-30.429688, -13.660714) "
  })), /*#__PURE__*/React.createElement("path", {
    d: "M435.9375,315.9375 C441.156314,315.9375 445.886929,317.456176 449.308993,319.932978 C452.603192,322.317235 454.6875,325.596953 454.6875,329.249309 L454.684,329.062 L417.19,329.062 L417.193218,328.918318 C417.311129,325.508983 419.244978,322.442468 422.269892,320.152181 L422.566007,319.932978 C425.988071,317.456176 430.718686,315.9375 435.9375,315.9375 Z",
    id: "Combined-Shape\u5907\u4EFD-2",
    stroke: "#CCCCCC",
    strokeWidth: "1.875",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-15-Copy-7\u5907\u4EFD-5",
    fill: "url(#linearGradient-5)",
    opacity: "0.490141369",
    transform: "translate(135.937500, 217.500000) scale(1, -1) rotate(180.000000) translate(-135.937500, -217.500000) ",
    x: "135",
    y: "114.375",
    width: "1.875",
    height: "206.25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.499,339.73 L502.5,361.875 L500.625,361.875 L500.625,339.73 L502.499,339.73 Z M502.5,105 L502.499,326.443 L500.625,326.443 L500.625,105 L502.5,105 Z",
    id: "\u5F62\u72B6\u7ED3\u5408\u5907\u4EFD-5",
    fill: "url(#linearGradient-6)",
    opacity: "0.490141369"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-11\u5907\u4EFD-25",
    stroke: "#CCCCCC",
    strokeWidth: "1.875",
    fillOpacity: "0.125300481",
    fill: "#CCCCCC",
    opacity: "0.2",
    transform: "translate(477.187500, 35.625000) scale(-1, 1) translate(-477.187500, -35.625000) ",
    x: "447.1875",
    y: "0.9375",
    width: "60",
    height: "69.375"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-11\u5907\u4EFD-26",
    stroke: "#CCCCCC",
    strokeWidth: "1.875",
    fillOpacity: "0.125300481",
    fill: "#CCCCCC",
    opacity: "0.2",
    transform: "translate(201.562500, 35.625000) scale(-1, 1) translate(-201.562500, -35.625000) ",
    x: "171.5625",
    y: "0.9375",
    width: "60",
    height: "69.375"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-11\u5907\u4EFD-27",
    stroke: "#CCCCCC",
    strokeWidth: "1.875",
    fillOpacity: "0.125300481",
    fill: "#CCCCCC",
    opacity: "0.2",
    transform: "translate(390.937500, 35.625000) scale(-1, 1) translate(-390.937500, -35.625000) ",
    x: "360.9375",
    y: "0.9375",
    width: "60",
    height: "69.375"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-11\u5907\u4EFD-28",
    stroke: "#CCCCCC",
    strokeWidth: "1.875",
    fillOpacity: "0.125300481",
    fill: "#CCCCCC",
    opacity: "0.2",
    transform: "translate(113.437500, 35.625000) scale(-1, 1) translate(-113.437500, -35.625000) ",
    x: "83.4375",
    y: "0.9375",
    width: "60",
    height: "69.375"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-11-Copy-2\u5907\u4EFD-3",
    stroke: "#CCCCCC",
    strokeWidth: "1.875",
    fillOpacity: "0.14291958",
    fill: "#FFFFFF",
    opacity: "0.701992754",
    x: "267.1875",
    y: "8.4375",
    width: "60",
    height: "69.375"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-11\u5907\u4EFD-29",
    stroke: "#CCCCCC",
    strokeWidth: "1.875",
    fillOpacity: "0.125300481",
    fill: "#CCCCCC",
    opacity: "0.2",
    transform: "translate(296.250000, 35.625000) scale(-1, 1) translate(-296.250000, -35.625000) ",
    x: "274.6875",
    y: "0.9375",
    width: "43.125",
    height: "69.375"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-11\u5907\u4EFD-30",
    stroke: "#CCCCCC",
    strokeWidth: "1.875",
    fillOpacity: "0.14291958",
    fill: "#FFFFFF",
    opacity: "0.701992754",
    x: "92.8125",
    y: "8.4375",
    width: "60",
    height: "69.375"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-11\u5907\u4EFD-31",
    stroke: "#CCCCCC",
    strokeWidth: "1.875",
    fillOpacity: "0.14291958",
    fill: "#FFFFFF",
    opacity: "0.701992754",
    transform: "translate(383.437500, 43.125000) scale(-1, 1) translate(-383.437500, -43.125000) ",
    x: "353.4375",
    y: "8.4375",
    width: "60",
    height: "69.375"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-11\u5907\u4EFD-32",
    stroke: "#CCCCCC",
    strokeWidth: "1.875",
    fillOpacity: "0.14291958",
    fill: "#FFFFFF",
    opacity: "0.701992754",
    transform: "translate(469.687500, 43.125000) scale(-1, 1) translate(-469.687500, -43.125000) ",
    x: "439.6875",
    y: "8.4375",
    width: "60",
    height: "69.375"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-11\u5907\u4EFD-33",
    stroke: "#CCCCCC",
    strokeWidth: "1.875",
    fillOpacity: "0.14291958",
    fill: "#FFFFFF",
    opacity: "0.701992754",
    x: "179.0625",
    y: "8.4375",
    width: "60",
    height: "69.375"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\u7F16\u7EC4-3\u5907\u4EFD-2",
    transform: "translate(172.500000, 108.750000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-12\u5907\u4EFD",
    stroke: "#CCCCCC",
    strokeWidth: "1.875",
    fill: "#FFFFFF",
    x: "0.9375",
    y: "0.9375",
    width: "255",
    height: "173.730469",
    rx: "11.25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.9375,150.527344 L255.9375,164.355469 C255.9375,167.203187 254.783234,169.781312 252.917039,171.647507 C251.050843,173.513703 248.472718,174.667969 245.625,174.667969 L245.625,174.667969 L11.25,174.667969 C8.40228176,174.667969 5.82415676,173.513703 3.95796132,171.647507 C2.09176588,169.781312 0.9375,167.203187 0.9375,164.355469 L0.9375,164.355469 L0.9375,150.527344 L255.9375,150.527344 Z",
    id: "Rectangle-12\u5907\u4EFD-2",
    stroke: "#CCCCCC",
    strokeWidth: "1.875",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-13\u5907\u4EFD",
    fill: "#F5F5F5",
    x: "11.2439682",
    y: "11.3818359",
    width: "234.387064",
    height: "128.452148"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\u7F16\u7EC4-2\u5907\u4EFD-2",
    transform: "translate(85.625000, 32.705357)",
    fill: "#CCCCCC",
    fillOpacity: "0.78676792",
    opacity: "0.906233825",
    stroke: "#CCCCCC",
    strokeWidth: "1.875"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.8125,-0.9375 C54.8944713,-0.9375 65.832943,3.99339696 73.7507253,11.9664964 C81.6661535,19.9372253 86.5625,30.9485328 86.5625,43.1116071 C86.5625,55.2746815 81.6661535,66.2859889 73.7507253,74.2567179 C65.832943,82.2298173 54.8944713,87.1607143 42.8125,87.1607143 C30.7305287,87.1607143 19.792057,82.2298173 11.8742747,74.2567179 C3.95884649,66.2859889 -0.9375,55.2746815 -0.9375,43.1116071 C-0.9375,30.9485328 3.95884649,19.9372253 11.8742747,11.9664964 C19.792057,3.99339696 30.7305287,-0.9375 42.8125,-0.9375 Z M18.5332994,22.2931496 C13.7897015,27.8996232 10.9270833,35.1690496 10.9270833,43.1116071 C10.9270833,51.9805962 14.4965192,60.0102486 20.2684093,65.8224637 C26.0379452,71.6323082 34.0083277,75.2263393 42.8125,75.2263393 C49.1051998,75.2263393 54.9721177,73.3905127 59.7607248,70.0520196 L59.7607248,70.0520196 Z M42.8125,10.996875 L42.2308039,11.0021111 C37.0067637,11.0962282 32.0893687,12.4555355 27.7681693,14.7889652 L27.7681693,14.7889652 L68.565,62.048 L68.7390801,61.809133 C72.490078,56.543316 74.6979167,50.0870405 74.6979167,43.1116071 C74.6979167,34.2426181 71.1284808,26.2129657 65.3565907,20.4007506 C59.5870548,14.5909061 51.6166723,10.996875 42.8125,10.996875 L42.8125,10.996875 Z",
    id: "\u5F62\u72B6\u7ED3\u5408"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M157.022149,174.916992 L161.028582,203.935547 L97.322711,203.935547 L101.329144,174.916992 L157.022149,174.916992 Z",
    id: "Rectangle-14\u5907\u4EFD",
    stroke: "#CCCCCC",
    strokeWidth: "1.875",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-14-Copy\u5907\u4EFD",
    stroke: "#CCCCCC",
    strokeWidth: "1.875",
    fill: "#F5F5F5",
    x: "74.696446",
    y: "200.932617",
    width: "110.564682",
    height: "6.25488281"
  })), /*#__PURE__*/React.createElement("g", {
    id: "chuangjiangongdan\u5907\u4EFD-3",
    transform: "translate(110.625000, 26.250000)",
    fill: "#CCCCCC",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.4707278,2.44750619 L20.4707278,1.875 C20.4707278,0.839466094 19.6312618,3.18201124e-17 18.5957278,0 L9.52927215,0 C8.49373825,1.90224492e-16 7.65427215,0.839466094 7.65427215,1.875 L7.65427215,2.44750619 L7.65427215,2.44750619 L1.875,2.44750619 C0.839466094,2.44750619 5.39317486e-16,3.28697229 0,4.32250619 L0,30 C-9.52282766e-17,31.0355339 0.839466094,31.875 1.875,31.875 L12.5921399,31.875 C13.0876386,31.875 13.4893196,31.473319 13.4893196,30.9778203 C13.4893196,30.4823217 13.0876386,30.0806406 12.5921399,30.0806406 L1.78006329,30.0806406 L1.78006329,30.0806406 L1.78006329,4.24186557 L7.65427215,4.24186557 L7.65427215,4.58469376 C7.65427215,5.62022767 8.49373825,6.45969376 9.52927215,6.45969376 L18.5957278,6.45969376 C19.6312618,6.45969376 20.4707278,5.62022767 20.4707278,4.58469376 L20.4707278,4.24186557 L20.4707278,4.24186557 L26.3449367,4.24186557 L26.3449367,16.3394071 C26.3449367,16.830958 26.7434174,17.2294388 27.2349684,17.2294388 C27.7265193,17.2294388 28.125,16.830958 28.125,16.3394071 L28.125,4.32250619 C28.125,3.28697229 27.2855339,2.44750619 26.25,2.44750619 L20.4707278,2.44750619 L20.4707278,2.44750619 Z M18.6906646,4.66533438 L9.43433544,4.66533438 L9.43433544,1.79435938 L18.6906646,1.79435938 L18.6906646,4.66533438 Z M6.94939488,16.4327432 L15.1233899,16.4327432 C15.6188886,16.4327432 16.0205696,16.8344242 16.0205696,17.3299229 C16.0205696,17.8254215 15.6188886,18.2271026 15.1233899,18.2271026 L6.94939488,18.2271026 C6.45389622,18.2271026 6.05221519,17.8254215 6.05221519,17.3299229 C6.05221519,16.8344242 6.45389622,16.4327432 6.94939488,16.4327432 Z M21.1756051,12.8189034 L6.94939488,12.8189034 C6.45389622,12.8189034 6.05221519,12.4172224 6.05221519,11.9217237 C6.05221519,11.4262251 6.45389622,11.024544 6.94939488,11.024544 L21.1756051,11.024544 C21.6711038,11.024544 22.0727848,11.4262251 22.0727848,11.9217237 C22.0727848,12.4172224 21.6711038,12.8189034 21.1756051,12.8189034 Z M22.2507911,24.1592547 L27.2278203,24.1592547 C27.723319,24.1592547 28.125,24.5609357 28.125,25.0564344 C28.125,25.551933 27.723319,25.9536141 27.2278203,25.9536141 L22.2507911,25.9536141 L22.2507911,25.9536141 L22.2507911,30.9849684 C22.2507911,31.4765193 21.8523104,31.875 21.3607595,31.875 C20.8692086,31.875 20.4707278,31.4765193 20.4707278,30.9849684 L20.4707278,25.9536141 L20.4707278,25.9536141 L15.4936987,25.9536141 C14.9982,25.9536141 14.596519,25.551933 14.596519,25.0564344 C14.596519,24.5609357 14.9982,24.1592547 15.4936987,24.1592547 L20.4707278,24.1592547 L20.4707278,24.1592547 L20.4707278,19.1279004 C20.4707278,18.6363495 20.8692086,18.2378687 21.3607595,18.2378687 C21.8523104,18.2378687 22.2507911,18.6363495 22.2507911,19.1279004 L22.2507911,24.1592547 L22.2507911,24.1592547 Z",
    id: "\u5F62\u72B6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "tongjifenxi\u5907\u4EFD-3",
    transform: "translate(196.875000, 28.125000)",
    fill: "#CCCCCC",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.4995312,26.2495313 C23.0092596,26.2609285 23.4165327,26.6774099 23.4165327,27.1872656 C23.4165327,27.6971214 23.0092596,28.1136027 22.4995312,28.125 L5.625,28.125 C5.11527165,28.1136027 4.70799852,27.6971214 4.70799852,27.1872656 C4.70799852,26.6774099 5.11527165,26.2609285 5.625,26.2495313 L22.5,26.2495313 L22.4995312,26.2495313 Z M23.4370313,0 C26.0240625,0 28.125,1.96124999 28.125,4.3734375 L28.125,20.0001563 C28.12125,22.4128125 26.0203125,24.3735938 23.4370313,24.3735938 L4.68750001,24.3735938 C2.10515625,24.3740625 0,22.4132813 0,20.000625 L0,4.37390626 C0,1.96124999 2.10468749,0 4.68796874,0 L23.4375,0 L23.4370313,0 Z M23.4370313,1.87546874 L4.68750001,1.87546874 C3.13546877,1.87546874 1.87500001,2.99578123 1.87500001,4.37390626 L1.87500001,20.0001563 C1.87500001,21.3778125 3.13546877,22.4985938 4.68750001,22.4985938 L23.4360937,22.4985938 C24.9885937,22.4985938 26.249063,21.3778125 26.249063,20.0001563 L26.249063,4.37390626 C26.25,2.99624999 24.9890625,1.87500001 23.4375,1.87500001 L23.4370313,1.87546874 Z M10.044375,8.90625001 C11.6714062,8.90625001 12.6660938,9.66750002 14.6671875,11.878125 L15.0435937,12.2948437 C16.5515625,13.95 17.2748437,14.4923437 18.0796875,14.4923437 C19.438125,14.4923437 20.4796875,13.9659375 21.294375,12.8671875 C21.4526683,12.6520609 21.6906565,12.5094395 21.9550057,12.4712851 C22.2193548,12.4331307 22.4879596,12.5026339 22.700625,12.6642187 C23.1445497,13.0038061 23.2338698,13.6367685 22.90125,14.0859375 C21.706875,15.695625 20.07,16.5234375 18.0796875,16.5234375 C16.4526562,16.5234375 15.4579687,15.7621875 13.456875,13.5515625 L13.0804687,13.1348438 C11.5725,11.4796875 10.8492188,10.9373438 10.044375,10.9373437 C8.47499999,10.9373437 7.515,11.6667187 6.97968751,13.2895313 C6.89757889,13.5441212 6.71709679,13.7553197 6.47841869,13.8761114 C6.23974059,13.9969032 5.96267723,14.0172621 5.70890624,13.9326562 C5.18052732,13.7511627 4.89694597,13.1779352 5.07328124,12.6478125 C5.87718751,10.2084375 7.59468749,8.90625001 10.0448438,8.90625001 L10.044375,8.90625001 Z",
    id: "\u5F62\u72B6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "ziyuan-3\u5907\u4EFD-3",
    transform: "translate(369.375000, 28.125000)",
    fill: "#CCCCCC",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.2481231,5.4234375 L25.731982,5.4234375 L25.731982,1.875 C25.731982,0.839466094 24.8916756,0 23.8551051,0 L1.87687688,0 C0.8403064,0 0,0.839466094 0,1.875 L0,28.125 C0,29.1605339 0.8403064,30 1.87687688,30 L26.2481231,30 C27.2846936,30 28.125,29.1605339 28.125,28.125 L28.125,7.2984375 C28.125,6.26290359 27.2846936,5.4234375 26.2481231,5.4234375 Z M23.8551051,1.875 L23.8551051,5.4234375 L1.87687688,5.4234375 L1.87687688,4.284375 L16.9294294,4.284375 C17.2544299,4.25624854 17.5039178,3.98448525 17.5039178,3.65859375 C17.5039178,3.33270225 17.2544299,3.06093896 16.9294294,3.0328125 L1.87687688,3.0328125 L1.87687688,1.875 L23.8551051,1.875 Z M26.2481231,28.125 L1.87687688,28.125 L1.87687688,7.2984375 L26.2481231,7.2984375 L26.2481231,12.975 L16.9294294,12.975 C16.5971621,12.975 16.2785037,13.1068607 16.0435552,13.3415742 C15.8086068,13.5762877 15.6766141,13.8946275 15.6766141,14.2265625 L15.6766141,21.2015625 C15.6766118,21.5330681 15.808754,21.8509281 16.0438383,22.0848977 C16.2789226,22.3188673 16.5975944,22.4496838 16.9294294,22.4484375 L26.2481231,22.4484375 L26.2481231,28.125 Z M26.2481231,21.2015625 L16.9294294,21.2015625 L16.9294294,14.2265625 L26.2481231,14.2265625 L26.2481231,21.2015625 Z",
    id: "\u5F62\u72B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9157286,4.49719193 L21.6384685,4.49719193 C21.9583721,4.46360852 22.2039474,4.1391192 22.2039474,3.75 C22.2039474,3.3608808 21.9583721,3.03639148 21.6384685,3.00280807 L19.9157286,3.00280807 C19.6827039,2.9783452 19.4582057,3.11516891 19.3354716,3.35645406 C19.2127375,3.59773921 19.2127375,3.90226079 19.3354716,4.14354594 C19.4582057,4.38483109 19.6827039,4.5216548 19.9157286,4.49719193 Z",
    id: "\u8DEF\u5F84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2434211,16.5 C19.2434211,17.0358984 19.5255576,17.5310889 19.9835526,17.7990381 C20.4415476,18.0669873 21.0058208,18.0669873 21.4638158,17.7990381 C21.9218108,17.5310889 22.2039474,17.0358984 22.2039474,16.5 C22.2039474,15.9641016 21.9218108,15.4689111 21.4638158,15.2009619 C21.0058208,14.9330127 20.4415476,14.9330127 19.9835526,15.2009619 C19.5255576,15.4689111 19.2434211,15.9641016 19.2434211,16.5 Z",
    id: "\u8DEF\u5F84"
  })), /*#__PURE__*/React.createElement("g", {
    id: "tongji\u5907\u4EFD-3",
    transform: "translate(285.000000, 28.125000)",
    fill: "#CCCCCC",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.0214236,28.125 C16.4273278,28.125 18.7502698,27.5425296 20.8243252,26.3775888 C21.156174,26.2111686 21.4050607,25.8783284 21.4050607,25.4622781 C21.4050607,25.0462278 21.2391362,24.7133876 20.9072874,24.4637574 C20.5754385,24.2973373 20.1606274,24.2973373 19.8287786,24.4637574 C18.0865721,25.4622781 16.095479,25.9615385 14.0214236,25.9615385 C7.46740869,25.9615385 2.15782699,20.6360947 2.15782699,14.0625 C2.15782699,7.82174556 6.88667319,2.74593195 12.9429148,2.16346154 L12.9429148,14.0625 C12.9429148,14.6449704 13.4406881,15.1442308 14.0214236,15.1442308 L27.0464912,15.1442308 C27.6272267,15.1442308 28.125,14.6449704 28.125,14.0625 C28.125,6.3239645 21.8198717,0 14.1043858,0 C6.3888999,0 0.000809418742,6.3239645 0.000809418742,14.0625 C-0.0821527954,21.8010355 6.22297548,28.125 14.0214236,28.125 Z M25.8850202,12.9807692 L15.0999324,12.9807692 L15.0999324,2.16346154 C20.8243252,2.66272189 25.3042847,7.23927515 25.8850202,12.9807692 Z",
    id: "\u5F62\u72B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.854202,19.9269771 C23.510399,20.5779829 23.0519949,21.2289887 22.4789898,21.7869937 C22.0205857,22.3449986 22.1351868,23.0890052 22.8227929,23.4610085 C23.510399,23.8330118 24.4272071,23.740011 24.8856112,23.1820061 C25.4586163,22.4379994 26.0316214,21.7869937 26.4900255,20.9499862 C26.8338285,20.3919813 26.6046265,19.6479746 25.8024194,19.3689722 C25.1148132,19.0899697 24.1980051,19.2759713 23.854202,19.9269771 L23.854202,19.9269771 Z",
    id: "\u8DEF\u5F84"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M475.798248,44.3408271 C479.723991,44.3408271 482.906434,47.4098579 482.906434,51.1956994 C482.906434,52.5939574 482.472313,53.8944345 481.726961,54.9786213 L483.399212,56.3810491 C483.813428,56.7282896 483.867722,57.3455721 483.520482,57.759788 C483.515277,57.7659963 483.509996,57.7721398 483.504639,57.7782169 C483.135597,58.1968682 482.500023,58.244827 482.072337,57.8862948 L480.361182,56.4519956 C479.126537,57.4498064 477.535144,58.0505717 475.798248,58.0505717 C471.872506,58.0505717 468.690063,54.9815409 468.690063,51.1956994 C468.690063,47.4098579 471.872506,44.3408271 475.798248,44.3408271 Z M475.798248,46.257243 C472.970025,46.257243 470.677297,48.4682652 470.677297,51.1956994 C470.677297,53.9231336 472.970025,56.1341558 475.798248,56.1341558 C478.626471,56.1341558 480.919199,53.9231336 480.919199,51.1956994 C480.919199,48.4682652 478.626471,46.257243 475.798248,46.257243 Z M479.977582,28.125 C481.08663,28.125 481.984909,28.9910789 481.984909,30.0603719 L481.984909,45.5704419 C481.411817,44.9162862 480.733341,44.353093 479.977582,43.8973129 L479.977582,30.0603719 L453.882327,30.0603719 L453.882327,53.2848341 L467.306328,53.2848341 C467.526131,53.9747942 467.843288,54.6212084 468.23271,55.2202059 L453.882327,55.2202059 C452.773279,55.2202059 451.875,54.354127 451.875,53.2848341 L451.875,30.0603719 C451.875,28.9910789 452.773279,28.125 453.882327,28.125 L479.977582,28.125 Z M467.692739,47.4787185 C467.406695,48.0883607 467.195925,48.7367102 467.070467,49.4140904 L459.904309,49.4140904 C459.350287,49.4140904 458.900645,48.9805671 458.900645,48.4464045 C458.900645,47.9122418 459.350287,47.4787185 459.904309,47.4787185 L467.692739,47.4787185 Z M466.927947,33.9233741 C468.412366,33.9233741 469.615758,34.6704276 469.615758,36.0251879 C469.615758,36.0842167 469.61074,36.1422779 469.605722,36.2003391 C469.61074,36.2584002 469.615758,36.3164614 469.615758,36.3754902 C469.615758,36.6280562 469.573605,36.8728808 469.495319,37.1022223 C469.765304,37.1225437 469.833553,37.4786522 469.800433,37.6015483 C469.765304,37.7341213 469.645868,38.477304 469.244403,38.6524552 C469.190205,39.09372 468.749597,40.1630129 468.317018,40.4039667 C468.2026,40.7320123 468.317018,41.1045713 468.317018,41.1045713 L468.329158,41.1097693 L468.329158,41.1097693 L468.420281,41.1488197 C468.595857,41.2241055 468.97352,41.3862604 469.382535,41.5632212 L469.692506,41.697592 C470.106525,41.8774518 470.50921,42.0541016 470.729825,42.1554782 C471.714419,42.6083553 472.29554,42.781571 472.617716,43.1183257 C471.658214,43.4454036 470.77499,43.9263435 470.008191,44.5417917 L460.910984,44.5417917 L460.910482,44.5528664 C460.909562,44.5714137 460.907638,44.6015732 460.906969,44.5460926 L460.906802,44.4584632 C460.906941,44.4173366 460.907304,44.3630924 460.907973,44.2921288 C460.904962,42.8696305 461.429878,42.9373685 463.12908,42.1554782 C463.625464,41.9265514 465.041367,41.3179757 465.43578,41.1487689 L465.526756,41.109763 C465.534726,41.1063487 465.538877,41.1045713 465.538877,41.1045713 C465.538877,41.1045713 465.631214,40.704917 465.538877,40.4039667 C465.107301,40.1630129 464.665689,39.09372 464.611492,38.6524552 C464.210026,38.477304 464.09059,37.7341213 464.055462,37.6015483 C464.022341,37.4786522 464.091594,37.1225437 464.360576,37.1022223 C464.28229,36.8728808 464.240136,36.6280562 464.240136,36.3754902 C464.240136,36.3164614 464.245154,36.2584002 464.250173,36.2003391 C464.245154,36.1422779 464.240136,36.0842167 464.240136,36.0251879 C464.240136,34.6713953 465.443529,33.9233741 466.927947,33.9233741 Z",
    id: "\u5F62\u72B6\u7ED3\u5408\u5907\u4EFD-6",
    fill: "#CCCCCC",
    fillRule: "nonzero"
  })))));
};

export default Error;
//# sourceMappingURL=error.js.map